import React from 'react';


const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-container">
        
        {/* BRAND */}
        <div className="footer-brand">
          <h3>Ink-Nepal</h3>
          <p>
            Bringing authentic Nepali stories to Canada.
            Curated novels, timeless literature, and cultural connection.
          </p>
        </div>

        {/* LINKS */}
        <div className="footer-links">
          <h4>Quick Links</h4>
          <a href="/shop">Shop</a>
          <a href="/about">About Us</a>
          <a href="/contact">Contact</a>
          <a href="/privacy">Privacy Policy</a>
        </div>

        {/* CONTACT */}
        <div className="footer-contact">
          <h4>Contact</h4>
          <p>Email: ink-nepal@gmail.com</p>
          <p>Toronto, Canada</p>
          <p>30-day return • Secure payments</p>
        </div>

        {/* SOCIAL */}
        <div className="footer-social">
          <h4>Follow Us</h4>
          <div className="social-links">
            <a href="#">Facebook</a>
            <a href="#">Instagram</a>
            <a href="#">Twitter</a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        © 2026 Ink-Nepal. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
